import DefaultSelectedLandDetails from "src/components/feature/selectedLandDetails";

const SelectedLandDetails = () => {
  return <DefaultSelectedLandDetails projectId={""} />;
};

export default SelectedLandDetails;